import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";

import Loader from "../../components/NewView/Common/Loader";

const MojuComponent = React.lazy(() =>
  import("../../components/NewView/RootComponents/MojuComponent")
);

const MojuPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>МОЖУ Харків | Програма професійної реалізації Yellow Hub</title>
          <meta
            name="description"
            content="МОЖУ Харків - безкоштовна програма професійної реалізації від Yellow Hub / Єловхаб: навчання, практика, кар'єрна підтримка та план розвитку."
          />
          <meta
            name="keywords"
            content="МОЖУ, можу Харків, програма МОЖУ, МОЖУ Yellow Hub, Yellow Hub, Єловхаб, Єлов Хаб, Еллоу Хаб, професійна реалізація, працевлаштування Харків, перекваліфікація Харків"
          />
          <link rel="canonical" href="https://yellowhub.com.ua/moju" />
          <meta property="og:title" content="МОЖУ Харків - програма Yellow Hub" />
          <meta
            property="og:description"
            content="30 днів навчання, практики та підтримки для пошуку роботи, нових навичок і плану розвитку."
          />
          <meta property="og:url" content="https://yellowhub.com.ua/moju" />
        </Helmet>
        <MojuComponent />
      </Suspense>
    </Fragment>
  );
};

export default MojuPage;
